// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bd5df4e8","455":"8085cf4e","782":"df05d3ac","977":"24babaa8"}[chunkId] + ".chunk.js";
};